import { render, staticRenderFns } from "./ExportPlaceData.vue?vue&type=template&id=04c8b6f2"
import script from "./ExportPlaceData.vue?vue&type=script&lang=js"
export * from "./ExportPlaceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports